import { useReviewsContext } from "@/components/Product/Reviews/context/reviews.context";

import { RatingSummary } from "./ratingSummary.component";

export const RatingSummaryContainer = () => {
    const { reviewsSummary, reviewsEnabled } = useReviewsContext();

    if (!reviewsEnabled) {
        return null;
    }

    return (
        <RatingSummary
            value={reviewsSummary?.summary.average}
            count={reviewsSummary?.summary.count}
            distributions={reviewsSummary?.distribution}
        />
    );
};
